<template>
  <v-container>
    <h1 class="text-center">Ticket-System</h1>
    <v-row>
      <v-col cols="12" md="6">
        <v-select
          :items="roles"
          item-text="name"
          item-value="id"
          label="Support-Rollen (dürfen Tickets bearbeiten)"
          v-model="supportRoleIds"
          multiple
          chips
          deletable-chips
        ></v-select>
      </v-col>
      <v-col cols="12" md="6">
        <v-select
          :items="channels"
          item-text="name"
          item-value="id"
          label="Kanal für das Auswahlmenü"
          v-model="menuChannelId"
        ></v-select>
      </v-col>
    </v-row>

    <h2>Ticket-Kategorien</h2>
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          :items="categories"
          item-text="name"
          item-value="id"
          label="Kategorie: Offen"
          v-model="openCategoryId"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="categories"
          item-text="name"
          item-value="id"
          label="Kategorie: In Bearbeitung"
          v-model="inprogressCategoryId"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="categories"
          item-text="name"
          item-value="id"
          label="Kategorie: Geschlossen"
          v-model="closedCategoryId"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-btn
          outlined
          :block="$vuetify.breakpoint.smAndDown"
          :loading="creatingCategories"
          @click="createCategories"
        >
          Kategorien automatisch erstellen
        </v-btn>
      </v-col>
    </v-row>

    <h2>Themen im Auswahlmenü</h2>
    <v-row v-for="(topic, index) in topics" :key="index" align="center">
      <v-col cols="12" sm="9">
        <v-text-field v-model="topic.label" label="Name" outlined dense></v-text-field>
      </v-col>
      <v-col cols="12" sm="2">
        <v-select
          :items="availableEmojis"
          item-text="label"
          item-value="value"
          label="Emoji"
          outlined
          dense
          clearable
          v-model="topic.emoji"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="1" class="d-flex align-center">
        <v-btn @click="removeTopic(index)" class="error" small block>Entfernen</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn @click="addTopic" class="primary" :block="$vuetify.breakpoint.smAndDown">Thema hinzufügen</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" @click="saveValues">Speichern</v-btn>
        <v-btn
          :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'ml-2'"
          :block="$vuetify.breakpoint.smAndDown"
          outlined
          :loading="postingMenu"
          @click="postMenu"
        >
          Menü jetzt posten
        </v-btn>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="settingsSaved"
      timeout="3000"
      color="green"
    >
      Einstellungen gespeichert!
    </v-snackbar>
    <v-snackbar
      v-model="postResult.show"
      timeout="5000"
      :color="postResult.success ? 'green' : 'red'"
    >
      {{ postResult.message }}
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      settingsSaved: false,
      creatingCategories: false,
      postingMenu: false,
      postResult: {
        show: false,
        success: false,
        message: '',
      },
      supportRoleIds: [],
      menuChannelId: null,
      openCategoryId: null,
      inprogressCategoryId: null,
      closedCategoryId: null,
      topics: [],
      roles: [],
      channels: [],
      categories: [],
      // Kuratierte, garantiert von Discord akzeptierte Standard-Emojis (keine Freitexteingabe -> kein Formatfehler mehr möglich)
      availableEmojis: [
        { label: '🎫 Ticket', value: '🎫' },
        { label: '❓ Frage', value: '❓' },
        { label: '❗ Wichtig', value: '❗' },
        { label: '🐛 Bug', value: '🐛' },
        { label: '🛠️ Technik', value: '🛠️' },
        { label: '🔧 Support', value: '🔧' },
        { label: '⚙️ Einstellungen', value: '⚙️' },
        { label: '💰 Zahlung', value: '💰' },
        { label: '💳 Bestellung', value: '💳' },
        { label: '🎁 Geschenk', value: '🎁' },
        { label: '📦 Paket', value: '📦' },
        { label: '📢 Ankündigung', value: '📢' },
        { label: '📝 Feedback', value: '📝' },
        { label: '💬 Chat', value: '💬' },
        { label: '📌 Sonstiges', value: '📌' },
        { label: '📅 Termin', value: '📅' },
        { label: '🚨 Dringend', value: '🚨' },
        { label: '🔒 Sperre', value: '🔒' },
        { label: '🎮 Spiel', value: '🎮' },
        { label: '🖥️ PC', value: '🖥️' },
        { label: '📱 App', value: '📱' },
        { label: '🚀 Sonstiges', value: '🚀' },
        { label: '⭐ Feedback', value: '⭐' },
        { label: '🏆 VIP', value: '🏆' },
      ],
    };
  },
  mounted() {
    BackendService.loadTicketSystemSettings().then((data) => {
      this.supportRoleIds = data.data.supportRoleIds || [];
      this.menuChannelId = data.data.settings.menu_channel_id;
      this.openCategoryId = data.data.settings.open_category_id;
      this.inprogressCategoryId = data.data.settings.inprogress_category_id;
      this.closedCategoryId = data.data.settings.closed_category_id;
      this.topics = (data.data.topics || []).map((topic) => ({ label: topic.label, emoji: topic.emoji || '' }));
      this.roles = data.data.roles;
      this.channels = data.data.channels;
      this.categories = data.data.categories;
    });
  },
  methods: {
    addTopic() {
      this.topics.push({ label: '', emoji: '' });
      this.$forceUpdate();
    },
    removeTopic(index) {
      this.$delete(this.topics, index);
      this.$forceUpdate();
    },
    createCategories() {
      this.creatingCategories = true;
      BackendService.createTicketCategories({
        roleIds: this.supportRoleIds,
      }).then((data) => {
        this.openCategoryId = data.data.openCategoryId;
        this.inprogressCategoryId = data.data.inProgressCategoryId;
        this.closedCategoryId = data.data.closedCategoryId;
        this.categories = [
          ...this.categories,
          { id: data.data.openCategoryId, name: 'Offene Tickets' },
          { id: data.data.inProgressCategoryId, name: 'In Bearbeitung' },
          { id: data.data.closedCategoryId, name: 'Geschlossene Tickets' },
        ];
      }).catch(() => {
        alert('Fehler beim Erstellen der Kategorien!');
      }).finally(() => {
        this.creatingCategories = false;
      });
    },
    saveValues() {
      BackendService.saveTicketSystemSettings({
        supportRoleIds: this.supportRoleIds,
        menu_channel_id: this.menuChannelId,
        open_category_id: this.openCategoryId,
        inprogress_category_id: this.inprogressCategoryId,
        closed_category_id: this.closedCategoryId,
        topics: this.topics,
      }).then(() => {
        this.settingsSaved = true;
      }).catch(() => {
        alert('nö!');
      });
    },
    postMenu() {
      this.postingMenu = true;
      BackendService.postTicketMenu().then((data) => {
        this.postResult = {
          show: true,
          success: data.data.success,
          message: data.data.success
            ? 'Das Auswahlmenü wurde gepostet!'
            : `Fehlgeschlagen: ${data.data.error}`,
        };
      }).catch(() => {
        this.postResult = {
          show: true,
          success: false,
          message: 'Fehlgeschlagen: Verbindung zum Server nicht möglich.',
        };
      }).finally(() => {
        this.postingMenu = false;
      });
    },
  },
};
</script>
